<template>
  <div>
    <!-- <Header/> -->
    <logo></logo>
    <div><img :src="image" class="bg"></div>
    <ServicesBar :list="this.list"></ServicesBar>
    <!-- 8.  Tabbar -->
    <Tabbar class="tab"></Tabbar>
  </div>
</template>

<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import ServicesBar from '../services/services_components/servicesBar.vue'
import api from '@/utils/api'

export default {
  name: 'Services', 
  created() {
      this.getServices()
  },
  data() {
      return {
          list: [],
          image: ''
      }
  },
  components: {
    Tabbar,
    ServicesBar,
    // Header,
    Logo,
  },
  methods: {
      async getServices() {
          const { data:data } = await api.getCategory()
          const { data:image } = await api.getCategoryImage()
          window.localStorage.setItem('services',JSON.stringify({
              time:new Date().getTime(),
              data: image
          }))
          console.log('我是一级产品', data)
          if (data.code === 200){
              this.list = data.data
          }
          if (image.code ===200){
              this.image = image.data.image
          }
      }
  },
}
</script>
<style scoped>
.bg{
   width: 46.875rem;
   height: 14.75rem; 
}
.tabbar{
    margin-top: 24.125rem;
}
</style>
